import { render, staticRenderFns } from "./manageTemplate.vue?vue&type=template&id=0257aeac&scoped=true&"
import script from "./manageTemplate.vue?vue&type=script&lang=js&"
export * from "./manageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./manageTemplate.vue?vue&type=style&index=0&id=0257aeac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257aeac",
  null
  
)

export default component.exports